import styled from '@emotion/styled';

const SidebarContainer = styled.aside`
`;

export { SidebarContainer };
